import { useStoreState } from '@ariakit/react'
import { FC } from 'react'
import styled from 'styled-components'

import { OptionCheckbox as LMFOptionCheckbox, TypeStyle } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { ErrorMessage } from '../../../../Modal/primitives/shared-form-styles'
import { LogoFormContainer } from '../LogoFormContainer'

export const TosCheckbox: FC = () => {
  const name = 'tos'
  const {
    embroidery: {
      modal: {
        forms: {
          dtcLogoEmbroideryForm: { termsOfServiceNoLinks },
        },
      },
    },
  } = useTranslation()
  const { logoSetupForm } = LogoFormContainer.useContainer()

  const tosValue = useStoreState(logoSetupForm, s => s.values.tos)
  const tosError = useStoreState(logoSetupForm, () => logoSetupForm.getError(name))

  return (
    <OptionCheckbox
      name={name}
      type='checkbox'
      value='yes'
      onChange={e => logoSetupForm.setValue('tos', e.target.checked ? ['yes'] : [])}
      checked={(tosValue && tosValue[0]?.includes('yes')) ?? false}
    >
      <TermsOfService>{termsOfServiceNoLinks}</TermsOfService>
      {tosError && (
        <ErrorMessage inset role='alert'>
          {tosError}
        </ErrorMessage>
      )}
    </OptionCheckbox>
  )
}

const OptionCheckbox = styled(LMFOptionCheckbox)`
  margin: ${props => props.theme.spacing(6)} 0 ${props => props.theme.spacing(6)} 0;
  padding: 0;
`

const TermsOfService = styled(TypeStyle.HeadlineMicro)`
  line-height: 20px;
`
